/* eslint-disable react/prop-types */
import React from 'react';
import { map, compact } from 'underscore';

import { ImageUploadLocal } from './image-upload-local';
import { ImageOptionsKey } from './consts';

const commonOptionStylesProp = {
  field: {
    fontWeight: 400,
    padding: 0,
  },
};

const getChoiceGroupOptions = ({
  i18n,
  options,
}) => map(options, ({
  key,
  text,
  onRenderBelowField = () => null,
  disabled,
}) => ({
  key,
  text: i18n.getString(text),
  disabled,
  styles: {
    ...commonOptionStylesProp,
  },
  onRenderField: (props, render) => (
    <div className="smart-page-image-editor-field">
      {props && render(props)}
      {onRenderBelowField(props.checked)}
    </div>
  ),
  height: 18,
  width: 18,
}));

export const getImageOptions = ({
  i18n,
  imageOptionsConfig,
  enableFacebookImport,
  onFileSelected,
  uploadedFileInfo,
  isMobile,
}) => {
  const options = compact([
    {
      key: ImageOptionsKey.DEFAULT,
      text: imageOptionsConfig[ImageOptionsKey.DEFAULT].text,
      onRenderBelowField: imageOptionsConfig[ImageOptionsKey.DEFAULT].onRenderBelowField,
    },
    {
      key: ImageOptionsKey.UPLOAD,
      text: _TL_('Upload your own'),
      onRenderBelowField:
        checked => (<ImageUploadLocal
          i18n={i18n}
          onFileSelected={onFileSelected}
          hidden={!checked}
          defaultFileName={uploadedFileInfo && uploadedFileInfo.file && uploadedFileInfo.file.name}
        />),
    },
    isMobile ? null : {
      key: ImageOptionsKey.FACEBOOKIMPORT,
      text: imageOptionsConfig[ImageOptionsKey.FACEBOOKIMPORT].text,
      disabled: !enableFacebookImport,
    },
  ]);

  const finalImageOptions = getChoiceGroupOptions({
    i18n,
    options,
  });

  return finalImageOptions;
};
